import script from "./ForgotPasswordScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordScreen.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPasswordScreen.vue?vue&type=style&index=0&id=e3b11208&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3b11208"]])

export default __exports__